export const COMPONENT_DATA_TABLE_LOADING = 'COMPONENT_DATA_TABLE_LOADING'
export const COMPONENT_DATA_TABLE_LOADED = 'COMPONENT_DATA_TABLE_LOADED'